import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DatabaseConnection } from './database-connection';

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  constructor(
    private http :HttpClient,
    private  dbConnection : DatabaseConnection
  ){}

  getDocument(data: any): Observable<Blob> {
    return this.http.post(this.dbConnection.remoteApiConnection.value +'contrat-appercu', data, { responseType: 'blob' });
  }
}
